import { render, staticRenderFns } from "./WorkflowFormBuilderRevisionGrantAccessDetailOptionButton.vue?vue&type=template&id=2159297c&"
import script from "./WorkflowFormBuilderRevisionGrantAccessDetailOptionButton.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderRevisionGrantAccessDetailOptionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports